import React from 'react';

import { Button, useTranslation, Divider } from '@testsigma/atoms';
import failedIcon from '@images/failed.svg';

import { useConnectionSyncFailed } from '../../hooks';

export const MetadataSyncFailure: React.FC = () => {
  const { t } = useTranslation();

  const { handleGoBack } = useConnectionSyncFailed();

  return (
    <>
      <div className='flex items-center justify-center h-[60px]'>
        <div className='ml-8 items-center my-4 font-medium text-[18px] text-secondary-unique-600'>
          {t('metadata-sync-faild.label')}
        </div>
      </div>
      <Divider type='solid' />
      <div>
        <div className='flex mt-5 mb-8 px-10  flex-col items-center justify-center h-full'>
          <div className='text-gray-500 text-center flex flex-col items-center'>
            <img
              src={failedIcon}
              className='empty-illustration'
              alt='Tick Illustration'
            />
          </div>
          <span className='mt-3 text-15 font-semibold'>
            {t('metadata-sync-failed.description')}
          </span>
          <div className='my-10 text-sm leading-5 text-center'>
            {t('metadata-sync-failure.message')}
          </div>
          <Button type='secondary' onClick={handleGoBack}>
            {t('common.go-back.label')}
          </Button>
        </div>
      </div>
    </>
  );
};
